enum Server {
    Unassigned = 0,
    SessionCheck = 2,
    Myle_SearchPatient,
    Myle_SearchPatientWithData,
    Myle_Login,
    ResumeSession,
    LoadPDFTags,
    Myle_LoadPatient,
    Myle_LoadCache = 29,
    Myle_GetLookups,
    Myle_LoadUserSettings,
    Myle_SearchAppointments = 35,
    Myle_UpdateAppointment,
    Myle_SearchPredefinedAppointments = 39,
    RAMQ_CheckSubscription,
    RAMQ_GetFullCachedSubscription,
    RAMQ_GetRamqPathology = 42,
    RAMQ_GetPatientsRegistration,
    RAMQ_EditResident,
    RAMQ_DeleteResident,
    RAMQ_EditRepresentant = 47,
    RAMQ_Inscription,
    RAMQ_DeInscription = 50,
    RAMQ_DeleteRepresentant,
    RAMQ_EditLocationSite,
    RAMQ_DeleteLocationSite,
    RAMQ_ChangeEffectiveDate,
    RAMQ_SetRamqPathology,
    Myle_APIStatus,
    Myle_MedicalDocuments_CreateNote = 59,
    Myle_GetSites,
    Myle_MedicalDocuments_Search = 62,
    Myle_MedicalDocuments_CountMedicalDocuments,
    Myle_UploadMedicalDocument,
    Myle_UpdateApprouvedDocumentMetadataRequestResponse,
    Myle_UpdateUnapprouvedDocumentMetadataRequestResponse,
    Myle_UploadAnyFile,
    Myle_ChangeEmployeeSite = 70,
    Myle_LoadDocument = 73,
    Myle_CountCommunication = 75,
    Myle_SetRecallToCompleted,
    Myle_SearchRecalls,
    Myle_GetRecall,
    Myle_UpsertRecall,
    Myle_SaveRecallCommunication,
    Myle_GetRecallsTypes,
    Myle_MarkMessageAsRead,
    Myle_SetMessageState = 83,
    Myle_SaveSendMessage = 86,
    Myle_SaveMessageNote,
    Myle_LoadNotesForTasksMessages = 89,
    Myle_MedicalDocuments_ApproveDocuments = 93,
    Myle_MedicalDocuments_GetSourceNames = 96,
    Myle_SearchMessagesOrTasks = 105,
    Configuration_ChangeLanguage,
    Myle_UserPassword_Change,
    Myle_Calendar_Load_Search_Config = 111,
    Myle_Calendar_Save_Search_Config,
    Myle_LoadAppointment,
    Myle_LogEvent = 118,
    Myle_Resources,
    Myle_DownloadFile,
    Configuration_UpdateAutoResponder = 122,
    Configuration_RemoveSignatureImage,
    Configuration_PINChange,
    Configuration_Validate_PIN,
    Configuration_GetEmployeeSharing,
    Configuration_UpdateEmployeeSharing,
    Configuration_UpdateEmployeeSettings,
    Configuration_UpdateEmployeeSettingsUsefulUrl,
    Configuration_UpdateEmployeePrintingSettings,
    Configuration_UpdateEmployeePdfTags = 133,
    Myle_MedicalDocument_SaveApprovedDocument = 135,
    Myle_Settings_SaveSignFileName,
    Myle_Settings_LoadSignatureByteArray,
    Myle_CreatePatient,
    Myle_Calendar_CreateAppointment,
    Myle_Calendar_LoadPredefinedAppointment,
    Myle_Calendar_DeletePredefinedAppointment,
    Myle_Calendar_CheckDoubleBooking,
    Myle_SetTaskStatus,
    Myle_MessageOrTask_LoadEmployeeSharing = 145,
    Myle_Task_SetTaskType = 148,
    Myle_Calendar_GenerateAppointmentsPDF = 150,
    Myle_Calendar_GenerateAppointmentConfirmationPDF,
    ARLMYLE_Labs_GetInBox,
    ARLMYLE_GetLab,
    Myle_Reporting_Sisense_SSO,
    Myle_Calendar_FetchAppointmentsPDF,
    Myle_UpdateUserSettings = 157,
    MedfarDictionnary_SearchDoctors,
    ARLMYLE_GetEncapsulatedData = 161,
    ARLMYLE_GetObservations,
    ARLMYLE_GetOrphanLabForwards,
    ARLMYLE_GetSpecificObservations,
    ARLMYLE_GetUnreadCount,
    ARLMYLE_SaveOrphanLabForwards,
    ARLMYLE_RemoveClinicianFromOrphanLabForwards,
    ARLMYLE_TakeAction = 168,
    Myle_LoadMyNotesData = 170,
    Myle_PAList_PrintLabelCompleteOne,
    Myle_Appointment_FindWorkingClinicians = 173,
    Myle_Appointment_Counts,
    Myle_LoadMyConsultationRequestsData,
    Myle_LoadExamRequests = 177,
    Myle_ARLMYLE_LinkLabToPatient = 180,
    Myle_DeleteLabRequest,
    Myle_PrintSelectedRequest = 183,
    Myle_Core_FetchPDF,
    Myle_Patient_FetchProfileImageFile,
    Myle_DeleteConsultationRequest,
    Myle_Patient_Demographics_Update,
    Myle_CreateLabEncounter,
    Myle_LoadTransactionsData,
    Myle_Patient_Identifiers_Update,
    Myle_LoadSalesData,
    Myle_SaveLabActionsNotes,
    Myle_Patient_Contacts_Update,
    Myle_Patient_OtherInfo_Update = 195,
    Myle_LoadClinicalWaitingLists,
    Myle_AddNewClinicalWaitingList,
    Myle_AddNewItemToWaitingList,
    Myle_DeleteClinicalWaitingList,
    Myle_DeleteItemFromClinicalWaitingList,
    Myle_SearchClinicalWaitingListItems,
    Myle_EditClinicalWaitingListName,
    Myle_GetBillingSelectedData,
    Myle_GenerateBillingCSV,
    Myle_Patient_Memo_Save,
    MedfarDictionnary_SearchParmacies,
    Myle_Patient_Clinicians_Update = 208,
    Myle_CheckIfSelectedPatientExists,
    Myle_EditAnItemOfWaitingList,
    Myle_Patient_Relationships_Update,
    Myle_Patient_History_GetMessage,
    Myle_Patient_History_GetTasks,
    Myle_Patient_History_GetCommunications,
    Myle_Patient_GenerateLabel,
    Myle_Patient_History_GetRecalls,
    Myle_Patient_History_GetRecallCommunication,
    Myle_Patient_History_CreateCommunication,
    Myle_MyNotesGeneratePDF,
    Myle_Protfolio_FetchMyNotesPDF,
    Myle_Lab_ChangeLabActionStatus,
    Myle_Lab_DeleteLabAction,
    Myle_Lab_GetActionsAndNotes,
    Myle_Patient_History_MarkSelectedRecallAsCompleted,
    Myle_Patient_History_CreateNewRecallEntry,
    Myle_Patient_History_GetAppointment,
    Myle_Lab_GetLabActionsInbox,
    Myle_GetActionsCount = 229,
    Myle_Appointment_ChangeStatus,
    Myle_Patient_History_GetPatientPrivateBill,
    Myle_CountPortfolios,
    Myle_SaveProfileImage,
    Myle_Patient_History_GetSelectedBillInformation,
    Myle_Patient_History_InvalidatePrivateBill,
    Myle_Lab_SaveLabSettings,
    Myle_Patient_History_GetBillableService,
    Myle_Patient_History_GeneratePatientAppointmentHistoryPDF,
    Myle_Patient_History_SavePrivateBill,
    Myle_Patient_History_GeneratePatientPrivateBillPDF,
    Myle_Patient_EMRTemplate_Get,
    Myle_Patient_Deactivate,
    Myle_Patient_Reactivate,
    Myle_Patient_CPP_Load = 245,
    Myle_Patient_Appointment_Search,
    Myle_Patient_CPP_Reorder,
    Employee_GetRawClickableText,
    Employee_GetClickableText,
    Employee_CreateClickableText,
    Employee_EditClickableText,
    Employee_DeletelickableTextTab,
    Employee_CheckTabNameExistForClickableText,
    Myle_Patient_EMRTemplateComments_Get,
    Myle_Patient_EMRTemplateComments_Save,
    Myle_Patient_EMRTemplate_ToggleValidity,
    Myle_Patient_EMRTemplate_ToggleCPPDisplay,
    Myle_Patient_CPP_MedicalAlertActivation = 260,
    Portal_Proxy_Refuse,
    Portal_Proxy_Register,
    Portal_Proxy_PatientRegistered,
    Portal_Proxy_LinkMylePatient,
    Portal_Proxy_FindLinkedMyleAccount,
    Myle_Patient_CPP_GeneratePDF,
    Myle_Patient_MedicalNote_LoadEncounter,
    MedfarBilling_GetBill,
    Myle_GetClientConfiguration,
    Myle_RefreshBackendCache,
    Myle_Patient_MedicalNote_AddEncounterNote,
    Myle_Patient_History_LoadMessageOrTaskNote,
    MedfarBilling_SearchDiagnosis,
    MedfarBilling_SearchOtherCode,
    Myle_Faxing_SRFaxNotification,
    Myle_Faxing_SendRx,
    Myle_Faxing_SendConsultationRequest,
    Myle_Faxing_SendMedicalNote,
    MedfarDictionary_SearchMedications,
    MedfarDictionary_ResolveMedicationFromSearch,
    Myle_LoadMySentFaxData,
    Myle_Patient_Encounter_FetchHandwrittenNoteImageFile,
    Portal_Proxy_SearchPatientProfiles,
    Portal_Proxy_GetSubscription,
    Portal_Proxy_DeleteAccount = 286,
    Portal_Proxy_LockAccount,
    Portal_Proxy_Subscription_ChangeManagedAccounts,
    Portal_Proxy_Subscription_MakePayment,
    Portal_Proxy_GetPlans = 291,
    Portal_Proxy_PostPaymentForm,
    Portal_Proxy_ResendLinkEmail,
    Portal_Proxy_CreateSubscription,
    Myle_Prescribe,
    Myle_Patient_MedicalNote_CreateEncounter,
    Myle_Billing_GenerateReportPDF,
    Myle_Patient_MedicalNote_SaveEncounter,
    Myle_Patient_GeneratePrescriptionPDF,
    Myle_Patient_History_PrivateBill_LoadCostCenterForMexico,
    Myle_AcceptAgreement,
    Myle_Imaging_HandNoteImages,
    Myle_Imaging_LoadHandNoteImage,
    Myle_Patient_MedicalNote_AddLabRequest,
    Myle_Patient_MedicalNote_UpdateConsultationDetails,
    MedfarDictionnary_SearchDiagnostics,
    MedfarDictionnary_SearchOffendingAgents,
    Myle_SaveHandNoteFile,
    Myle_DeleteHandNoteFile,
    Myle_Patient_MedicalNote_CreateNewForm,
    Myle_Patient_MedicalNote_GenerateToken = 313,
    MedfarDictionnary_GetVigilanceMonographie,
    Myle_Patient_MedicalItem_SaveMedicalItemProblem,
    Myle_Patient_MedicalItem_SaveMedicalItemMedicalReaction,
    Myle_Patient_MedicalItem_SaveMedicalItemRiskFactor,
    Myle_Patient_MedicalItem_SaveMedicalItemAlert,
    Myle_Patient_MedicalItem_SaveMedicalItemFamilyHistory,
    Myle_Patient_MedicalItem_SaveMedicalItemImmunization,
    Myle_Patient_MedicalItem_SaveMedicalItemVitalSign,
    Myle_Patient_MedicalItem_DeleteMedicalItem,
    Myle_Patient_MedicalNote_LoadMedicalItems,
    Myle_Patient_MedicalNote_GetStatus,
    Myle_Patient_MedicalNote_SaveAsNewEncounter,
    Myle_Patient_MedicalNote_SignoffEncounter,
    Myle_Patient_MedicalNote_GetFormsList,
    Myle_UpsertMedication,
    Myle_Patient_MedicalNote_DeleteForm,
    Myle_DeleteMedication,
    Myle_Patient_MedicalNote_IsPersistant,
    Myle_UpdateMedicationDates,
    Myle_UpdateMedicationStatus,
    MedfarBilling_AddFavoriteCode,
    MedfarBilling_LoadFavoriteCode,
    MedfarBilling_RemoveFavoriteCode,
    MedfarBilling_GenerateBill,
    MedfarDictionnary_GetVigilanceNumberOfAlerts = 340,
    Myle_ExternalSearch = 342,
    Myle_GetFavoritePrescription = 344,
    Myle_ToggleFavorite,
    Myle_Patient_MedicalNote_GenerateNotePDF = 348,
    Myle_Patient_MedicalNote_AutoSaveEncounter = 350,
    Myle_ExternalSearch_UpdatePatient = 353,
    Myle_Patient_Medication_GeneratePDF,
    MedfarBilling_DeleteBill,
    MSA_LocateCertificateKeys,
    MSA_GetCertificate,
    Configuration_UpdateEmployeeThumbprintDSQ,
    DSQ_SynchroniseEmployee,
    DSQ_SynchronisePatient,
    DSQ_AcceptSyncPatient,
    Myle_AddEncounterEmployeeRelation,
    DSQ_MedicationSummary,
    Myle_Settings_SavePreferedFaxNumber,
    DSQ_Prescribe,
    Myle_Faxing_ResendFax,
    GetDictionaryCache,
    Myle_Patient_DeletePendingPrescription = 369,
    MedfarBilling_CheckIfHasSpecialtyCode,
    MedfarBilling_SaveSpecialty,
    DSQ_CancelPrescribe,
    Myle_MedicalDocuments_CheckIfHasBatchScan,
    Myle_MedicalDocuments_StartNewBatchProject,
    Myle_MedicalDocuments_UploadBatchScan,
    Myle_UpdateMedicationDSQInfo,
    Configuration_ChangeUnit,
    DSQ_GetLabs,
    DSQ_OpenLab,
    MedfarBilling_VerifyAnnualGmfFee,
    Myle_Patient_Enrollment_GenerateRAMQForm,
    Myle_Patient_MedicalNote_ManageAppointmentState,
    Myle_Resident_SendPendingApproval,
    Myle_Resident_LoadPendingStatus,
    Myle_Resident_CheckApprovalStatus,
    Myle_Resident_GetPendingApprovals,
    Portal_Proxy_SendDocument = 389,
    Myle_MedicalDocuments_SplitPDFForBatchScan = 393,
    Myle_MedicalDocuments_GetBatchScanPagesInfo = 395,
    Myle_MedicalDocuments_EnlargePage,
    Myle_MedicalDocuments_AttachDocumentFromBatchScan,
    Myle_SplitPdf_Proxy_SplitPDF,
    Portal_Proxy_DeletePrivateBill = 407,
    Myle_Resident_LoadPendingApprovalNotes = 409,
    ARLMYLE_GetEncapsulatedDataInfo = 413,
    Myle_Faxing_GetSentFaxStatus,
    Myle_Faxing_FetchPdf = 416,
    Myle_Resident_ApprovePendingApproval,
    Myle_AdministrationUpsertService,
    Myle_AdministrationGetEmployees,
    Myle_AdministrationGetEmployeeGroups,
    Myle_AdministrationGetSites,
    Myle_Resident_ReturnPendingApproval,
    Myle_Administration_GetAvailableResources = 425,
    Portfolio_GetSentFaxPreview = 428,
    Myle_PrintConsultationRequest = 430,
    Myle_Scheduling_AddRulesSet,
    Myle_Logoff,
    Myle_Scheduling_CheckRuleSetAvailability,
    Myle_SetApssCookie,
    Myle_UploadApssAttachments,
    Myle_GetPatientPrintableFiles,
    Apss_FowardToApss,
    Portal_AppointmentSearch = 439,
    Portal_GlobalAppointmentSearch,
    Portal_AppointmentSave = 441,
    Myle_Calendar_CheckModifications = 443,
    Myle_ComboAppointment_ChangeStatus = 445,
    Myle_AdministrationUpsertCombo = 450,
    Portal_UpdateAppointmentExternalLink,
    IntegrationAPI_SearchPatient,
    Myle_Patient_History_DeleteSelectedBill,
    Myle_Patient_History_CloseSelectedBill,
    Myle_Scheduling_CheckRulesetValidity = 456,
    MedfarDictionnary_SearchSpecialisation,
    Myle_Scheduling_GetRuleset,
    Myle_Scheduling_UpdateRuleSet,
    Myle_PrivateBill_LoadLightPrivateBill,
    Myle_GetIntervenors,
    Portal_Proxy_GetPatientProfile,
    Myle_Scheduling_AddServicePredefinedAppointment,
    Myle_Scheduling_LoadLightTemplate = 465,
    Myle_Scheduling_GetTemplateInfo,
    Myle_Scheduling_DeleteTemplate,
    Myle_Scheduling_SavePredefinedTemplate,
    Myle_Scheduling_UpdatePredefinedTemplate,
    Portal_Proxy_GetPatientPortalProfileOverview = 471,
    Myle_Scheduling_LoadLightTemplateForSpecificEmployee,
    Myle_Scheduling_AddScheduleFromTemplate,
    Portal_Proxy_GetRecentActivity,
    Myle_Scheduling_DeleteServiceAndRuleSet = 476,
    Myle_Scheduling_DeleteSinglePredefinedAppointmentOrRuleSet,
    Portal_Proxy_SuspendSubscription,
    MedfarDictionnary_LoadClinicSetting = 480,
    Portal_Proxy_UnsuspendSubscription,
    Myle_Communications_VerifyEmployeesOnVacation,
    Myle_Core_GenerateChart,
    Portal_Proxy_GetAccount,
    Portal_Proxy_Account_GetSharedAccounts,
    Portal_Proxy_Account_UpdateSharedAccount,
    Portal_Proxy_Account_Relink,
    Portal_Proxy_GetPortalConfiguration,
    Myle_MedicalDocuments_RemovePage,
    Myle_MedicalDocuments_RotatePage,
    Myle_Proxy_ChartEngine,
    Myle_Patient_GrowthCurves_GeneratePDF,
    Portal_Proxy_GetPatientProfileRelinkPreview,
    Myle_GetPatientForms = 495,
    Myle_LoadConsentPrograms,
    Myle_Patient_UpdateConsentProgram = 499,
    Portal_Proxy_GetRegisterInfo,
    Portal_Proxy_AccountChangeEmail = 502,
    MedfarDictionnary_SearchLabs = 508,
    MedfarDictionnary_RemoveLab = 510,
    Myle_Faxing_SendLabRequest,
    MedfarDictionnary_UpsertLab,
    Myle_Patient_Merged_GrowthCurvesAndVitalsPDF = 525,
    Myle_Patient_VitalSigns_GeneratePDF,
    Myle_PrintMultipleFetchUrlIntoSingleFile,
    Myle_Faxing_SendGenericPDF,
    GetSearchableEmployees,
    GetEmployeeInfo,
    UpdateActivateEmployee,
    ReinitEmployeePassword,
    MedfarDictionnary_LoadDoctorInfo,
    Myle_Admin_CreateEmployee = 535,
    Myle_Admin_UpdateDemographic,
    Myle_Admin_UpdatePractice,
    Myle_Admin_UpdateConfiguration,
    Myle_Admin_UpdateTools,
    Myle_FrontpageCampaign_Stats,
    Myle_FrontpageCampaign_GetRandom,
    Portal_Proxy_GetTransactions,
    Portal_Proxy_GetTransactionDetails,
    Portal_Proxy_RefundTransaction,
    Portal_Proxy_PreviewChangeSubscription,
    Portal_Proxy_ChangeSubscription,
    Portal_Proxy_GetPaymentCustomer,
    Myle_GetFrontpageCampaign = 549,
    Myle_FrontpageCampaign_GetActiveId,
    Myle_SaveEncounterTimeSpent,
    ExternalProjet_Christus_RISClient_SendRequest,
    Myle_ChristusRISProxySendRequestRIS,
    Myle_LoadLISRISCodes,
    UpdateEmployeeType,
    GetClickableTextSpecificUser,
    Create_List_ClickableText,
    MedfarDictionnary_LoadRegions,
    MedfarDictionnary_LoadTowns,
    External_MSAinit,
    External_MSAGetInstance,
    External_MSAConnectionSuccess,
    DeleteProfilePicEmployee = 565,
    ExternalProjet_Christus_Apex_SyncRequest,
    MYLE_ChristusApexProxySearchPatient,
    Myle_UpdatePatientChartNumberAndIdentifier01,
    Employee_DeleteClickableTextSection,
    Employee_GetClickableTextCategories,
    Employee_getClickableTextDetails,
    Import_ClickableText_List,
    LoadAllUsersWithClickableText,
    GetClickableTextDetailsSpecificUserSpecificTab,
    DSQ_GetPendingMedications,
    DSQ_GetMedicationSummaryDetails,
    DSQ_GetPendingMedicationDetails,
    DSQ_GetLocations,
    DSQ_GetDelivranceList,
    DSQ_GetDelivranceDetails,
    DSQ_GetLocationDetails,
    DSQ_SynchronizeLocation,
    Myle_LoadEmployerOrganisationCache = 584,
    Myle_Admin_UpdateUser,
    Myle_Admin_AddUserToGroup = 587,
    Myle_Admin_UpsertGroupSetting,
    Myle_Admin_LoadGroupSetting,
    GetAllGroupsWithClickableText,
    Myle_Admin_GetAllBillableService = 593,
    Myle_Admin_UpsertBillableService,
    Myle_Admin_RenameGroup,
    Myle_Forms_GetTemplateProxy = 598,
    Myle_ImportDSQLabs = 603,
    Myle_Forms_LoadAllFavoriteForms = 608,
    Myle_Forms_AddFavoriteForm,
    Myle_Forms_RemoveFavoriteForm,
    Myle_ImportDSQImg,
    Myle_Portfolio_ToggleFailedFaxVisibilty,
    Myle_Patient_Portal_GetSharedItem,
    Myle_Patient_Portal_SyncSharedItem,
    Myle_Patient_Portal_RevokeSharedItem,
    Myle_DeleteMedicalEncounter,
    Myle_UnapproveMedicalEncounter,
    Myle_Administration_Site_Upsert,
    Myle_PrintDSQDocument,
    Myle_LoadAdminLogData,
    Myle_CreateAdminLog,
    Myle_Administration_Site_LoadCostCenter,
    Myle_MedicalDocuments_RevokeApproval,
    Myle_User_Email_Insert,
    Myle_Verify_Email,
    Myle_Lists_GeneratePDF,
    Myle_Employee_Get_Emails = 628,
    Myle_Employee_Save_Emails,
    Myle_Employee_Resend_Verification_Code,
    Myle_PwdRecovery_Password_Reset_Email,
    Myle_PwdRecovery_Password_Reset,
    Myle_PwdRecovery_Validate_Token,
    // Myle_PrivateBill_PrintAllPrivateBills, // referenced by commented-out code
    Myle_User_ValidateIfServiceCurrentlyUsed = 638,
    Myle_User_DisableServices,
    ExternalProjet_Christus_LISClient_UpsertRequest,
    Myle_Communications_LoadMessageTaskView,
    Myle_MarkMessagesAsUnRead,
    Myle_ChristusLISProxySendRequestLIS,
    ExternalProjet_Christus_LISClient_CancelRequest,
    MedfarDictionnary_GetScreeningTestProfilesDefinitions = 647,
    Myle_Patient_MedicalItem_SaveMedicalItemScreeningTest = 649,
    Configuration_UpdateActiveDepartment,
    Myle_LoadSelectedLabRequest,
    ExternalFacturationNetClient_GetClaimInfo = 653,
    ExternalFacturationNetClient_CreateClaimWebUI,
    ExternalFacturationNetClient_OpenClaimWebUI,
    FacturationNetClient_GetClaimInfo,
    FacturationNetClient_CreateClaimWebUI,
    FacturationNetClient_OpenClaimWebUI,
    ExternalFacturationNetClient_GetClaimInfoBatch,
    ExternalFacturationNetClient_CancelClaim,
    FacturationNetClient_CancelClaim,
    Myle_Patient_History_SingleTask,
    ExternalFacturationNetClient_UpdateFacturationNetUser,
    FacturationNetClient_UpdateFacturationNetUser,
    Myle_Portfolio_LoadPortalSyncHistory,
    Myle_Patient_MedicalNote_UpsertConsultationRequest,
    Myle_LoadSelectedConsultationRequest,
    Myle_Patient_MedicalNote_ToggleIsInvalidMedicalRequest,
    Myle_Patient_Contacts_Emails_Update,
    Myle_Patient_History_SingleMessage,
    ExternalPatientSearch_SearchPatient,
    Myle_Patient_History_SingleRecall,
    Myle_LoadAvailableLinkedCareElements,
    Myle_LoadFollowUps,
    Myle_Portfolio_LoadPortalPendingItems,
    Myle_LoadScreeningsAndFollowUps,
    Myle_Appointment_Portal_ChangeStatus,
    Myle_MedicalRequest_UpdateStatus,
    Myle_LoadMedicalRequestComments,
    Myle_SaveMedicalRequestComment,
    Myle_LoadAttachedCommunications = 682,
    Myle_MedicalRequest_MarkAsPrinted,
    Myle_Patient_Telemed_SendInvitation,
    Myle_Patient_Telemed_GetExistingRoomInformation,
    Myle_Patient_Telemed_GetInvitationInformation,
    Myle_ExternalCommunication_SaveSendMessage,
    Myle_ExternalCommunication_LoadMessage,
    Myle_Patient_Telemed_RoomLogin,
    QuebecVaccinationRegistry_Proxy_GetToken,
    Myle_CnesstModule_GetAttachmentCategories,
    Myle_CnesstModule_LoadEncounterForms,
    Myle_CnesstModule_LoadForm,
    Myle_CnesstModule_LoadFormAttachments,
    Myle_CnesstModule_LoadPortfolioCnesstForms,
    Myle_CnesstModule_PreviewFormPdf,
    Cnesst_Proxy_GetAttachmentCategories,
    Cnesst_Proxy_SendAdHocForm,
    Cnesst_Proxy_SendFinalReportForm,
    Cnesst_Proxy_SendMedicalCertificateForm,
    Cnesst_Proxy_SendMedicalEvaluationForm,
    Cnesst_Proxy_SendMedicalReportForm,
    Myle_CnesstModule_SaveAdHocForm,
    Myle_CnesstModule_SaveFinalReport,
    Myle_CnesstModule_SaveMedicalCertificate,
    Myle_CnesstModule_SaveMedicalEvaluation,
    Myle_CnesstModule_SaveMedicalReport,
    Myle_CnesstModule_SendAdHocForm,
    Myle_CnesstModule_SendFinalReport,
    Myle_CnesstModule_SendMedicalCertificate,
    Myle_CnesstModule_SendMedicalEvaluation,
    Myle_CnesstModule_SendMedicalReport,
    Myle_Attachments_Download,
    Myle_CnesstModule_DeleteForm,
    Myle_ExternalCommunication_LoadInboxMessages,
    Myle_ExternalCommunication_LoadOutboxMessages,
    Myle_ExternalCommunication_LoadPatientMessages,
    Myle_LoadBearerTokenForEmployeeReg,
    Myle_ExternalCommunication_ResendMessage = 720,
    ExportableFile_GetRadpdfFetchUrl,
    Myle_Faxing_SendExportableFileFax,
    Myle_Patient_Portal_CopyRequestPdfToPortal,
    Myle_Patient_Portal_CopyPermanentPdfForPortal,
    Myle_Patient_MedicalNote_ReloadForms = 726,
    Myle_Patient_Representant_GetAll,
    Myle_Patient_Representant_AddEmail,
    Myle_Patient_ExternalRepresentant_Create = 730,
    Myle_ExternalCommunication_LoadImportedPatientMapping = 732,
    Myle_ExternalCommunication_ImportDocument = 734,
    Myle_ExternalCommunication_ImportPatientProfile = 736,
    Myle_CnesstModule_SaveAdditionalWrittenMedicalInformation,
    Myle_CnesstModule_SaveSupplementaryReport,
    Myle_CnesstModule_SaveWorkerWithdrawalCertificate,
    Myle_CnesstModule_SaveTemporaryWorkAssignmentLegacy201605,
    Myle_CnesstModule_Patient_LoadAllForms,
    Myle_CnesstModule_MarkSecondaryCnesstFormAsClosed,
    Myle_CnesstModule_GetWorkerClaimExportableFile = 744,
    Myle_CnesstModule_ChangeFormSentStatus,
    Myle_Patient_UpdateDateOfBirth,
    Myle_Patient_MedicalNote_SearchRecentlyUsedRadPdf = 748,
    Myle_Patient_MedicalNote_AddRadPdfToEncounter,
    Myle_Patient_MedicalNote_DuplicateForm,
    QuebecVaccinationRegistry_GetAuthDetails,
    QuebecVaccinationRegistry_GetValues,
    QuebecVaccinationRegistry_SearchPatient,
    QuebecVaccinationRegistry_GetPatientById,
    QuebecVaccinationRegistry_GetPatientByDemographics,
    QuebecVaccinationRegistry_GetPractitionersBySearch,
    QuebecVaccinationRegistry_GetPractitionerById,
    QuebecVaccinationRegistry_GetMedicationByTradeName,
    QuebecVaccinationRegistry_GetVaccinationRefusal,
    QuebecVaccinationRegistry_GetPreferences,
    QuebecVaccinationRegistry_SavePreferences,
    QuebecVaccinationRegistry_GetLocationsBySearch,
    QuebecVaccinationRegistry_GetImmunizationById,
    QuebecVaccinationRegistry_GetLocationById,
    QuebecVaccinationRegistry_SyncImmunization,
    QuebecVaccinationRegistry_EditImmunization,
    QuebecVaccinationRegistry_DeleteImmunization,
    QuebecVaccinationRegistry_OverrideImmunizationStatus,
    QuebecVaccinationRegistry_ResetImmunizationStatus,
    QuebecVaccinationRegistry_GetCondition,
    QuebecVaccinationRegistry_AddCondition,
    QuebecVaccinationRegistry_AddVaccinationRefusal,
    QuebecVaccinationRegistry_WithdrawVaccinationRefusal,
    QuebecVaccinationRegistry_GetImmunizationProfile,
    QuebecVaccinationRegistry_SetConditionEndDate,
    QuebecVaccinationRegistry_AddAllAntigensVaccinationRefusal,
    QuebecVaccinationRegistry_GenerateImmunizationProfilePdf,
    QuebecVaccinationRegistry_Proxy_RenewToken,
    QuebecVaccinationRegistry_Proxy_InvalidateToken,
    QuebecVaccinationRegistry_Proxy_GetValues,
    QuebecVaccinationRegistry_Proxy_GetPractitionersBySearch,
    QuebecVaccinationRegistry_Proxy_GetPractitionerById,
    QuebecVaccinationRegistry_Proxy_GetMedicationByTradeName,
    QuebecVaccinationRegistry_Proxy_GetAuthenticationDetails,
    QuebecVaccinationRegistry_Proxy_GetVaccinationRefusal,
    QuebecVaccinationRegistry_Proxy_GetPatientById,
    QuebecVaccinationRegistry_Proxy_GetPatientBySearch,
    QuebecVaccinationRegistry_Proxy_GetPatientByDemographics,
    QuebecVaccinationRegistry_Proxy_GetLocationsBySearch,
    QuebecVaccinationRegistry_Proxy_GetLocationById,
    QuebecVaccinationRegistry_Proxy_GetImmunizationById,
    QuebecVaccinationRegistry_Proxy_AddImmunization,
    QuebecVaccinationRegistry_Proxy_AddImmunizationAndPatient,
    QuebecVaccinationRegistry_Proxy_EditImmunization,
    QuebecVaccinationRegistry_Proxy_DeleteImmunization,
    QuebecVaccinationRegistry_Proxy_OverrideImmunizationStatus,
    QuebecVaccinationRegistry_Proxy_ResetImmunizationStatus,
    QuebecVaccinationRegistry_Proxy_GetCondition,
    QuebecVaccinationRegistry_Proxy_AddCondition,
    QuebecVaccinationRegistry_Proxy_AddVaccinationRefusal,
    QuebecVaccinationRegistry_Proxy_WithdrawVaccinationRefusal,
    QuebecVaccinationRegistry_Proxy_GetImmunizationProfile,
    QuebecVaccinationRegistry_Proxy_SetConditionEndDate,
    QuebecVaccinationRegistry_Proxy_AddAllAntigensVaccinationRefusal,
    QuebecVaccinationRegistry_AddPreference,
    QuebecVaccinationRegistry_LinkPatient,
    QuebecVaccinationRegistry_UpdatePreference,
    QuebecVaccinationRegistry_SaveDeletionReason,
    QuebecVaccinationRegistry_InvalidateAndDeleteImmunization,
    QuebecVaccinationRegistry_Proxy_AddImmunizationAndUpdatePatient = 811,
    QuebecVaccinationRegistry_Proxy_UpdateImmunizationAndPatient,
    Myle_Questionnaire_Submit,
    Myle_Questionnaire_GeneratePdf,
    Myle_Individual_AddContact,
    Myle_Questionnaire_GetFormTemplate,
    QuebecVaccinationRegistry_GetAntigensByTradeName,
    MedfarDictionnary_GetPharmacy,
    QuebecVaccinationRegistry_Offline_GetLocationsBySearch,
    QuebecVaccinationRegistry_Offline_GetPractitionersBySearch,
    Myle_Questionnaire_GetQuestionnaireNotices,
    Myle_Questionnaire_UpdateQuestionnairePatientContactedDate,
    Myle_Questionnaire_GetQuestionnaireNoticeCounts,
    Myle_Admin_Questionnaire_GetQuestionnaireForm,
    Myle_Admin_Questionnaire_UpdateQuestionnaireIntroduction,
    Myle_Portfolio_LoadMyPreventiveActivities,
    Myle_Patient_Update_FromRamqInscription,
    Myle_Patient_MedicalNote_NewObstetricalFile,
    Myle_Patient_MedicalNote_ObstetricalFileContribution,
    Myle_Patient_MedicalSummary_SaveObstetricalSummary,
    Myle_Patient_MedicalSummary_LoadObstetricalSummary,
    Myle_Patient_MedicalNote_DeleteObstetricalFile,
    Myle_Questionnaire_GetAvailableQuestionnaires,
    Myle_Patient_MedicalNote_GetPreviousObstetricalPdf,
    ExternalBilling_DeleteClaim = 836,
    ExternalBilling_GetClaim,
    ExternalBilling_GetClaimsByEncounterIds,
    ExternalBilling_SaveUserInfo,
    ExternalBilling_DeleteUserInfo,
    Myle_Patient_MedicalNote_UpdateObstetricalFileForm,
    Myle_ExternalCommunication_DeleteInboxMessages,
    Myle_ExternalCommunication_RestoreInboxMessages,
    ExternalBilling_GetUserInfo,
    ExternalBilling_CreateClaim,
    WorkSafeBc_CreateForm,
    WorkSafeBc_GetExistingFormList,
    WorkSafeBc_GetPhysicianReportForm,
    WorkSafeBc_SavePhysicianReportForm,
    WorkSafeBc_DeleteForm,
    Myle_Patient_MedicalNote_GenerateObstetricalFilePdf,
    ExportableFile_GetWorkSafeBcFormFetchUrl,
    WorkSafeBc_GeneratePhysicianReportFilePdf,
    Myle_ObstetricalFile_GetExportableFile,
    Apss_Proxy_UploadFiles,
    Myle_Patient_MedicalNote_GetEncounterPatientFormsByName,
    Myle_Calendar_LoadAppointmentThirdPartyPatientInfo = 858,
    Myle_Calendar_LinkAppointmentThirdPartyPatient,
    Myle_OntarioPatientEnrollment_GetEnrollmentsForPatient,
    Myle_OntarioPatientEnrollment_UpsertEnrollment,
    Myle_OntarioPatientEnrollment_TerminateEnrollment,
    Myle_OntarioPatientEnrollment_DeleteEnrollment,
    Myle_OntarioPatientEnrollment_GetEnrollmentForStatus,
    Myle_AppointmentCertificate_GeneratePdf,
    Myle_AppointmentConfirmation_AppointmentCertificate_GenerateMergePdf,
    MedfarDictionary_GetDefaultCanadaTaxes,
    MedfarDictionnary_SearchWorkSafeBcCodeDictionary,
    MedfarDictionnary_SearchWorkSafeBcIcd9CodeDictionary,
    RAMQ_GetCachedRamqSubscriptionStatusDetails,
    Myle_Faxing_LoadInboundFaxes,
    Myle_Faxing_RestoreInboundFaxes,
    Myle_Patient_MedicalNote_GetLabResultsObstetricalFile,
    Myle_SaveSignedPrintAuthorization,
    Myle_GetEncounterIdFrom_SharedItem = 876,
    Myle_Faxing_DeleteInboundFaxes,
    Myle_Patient_BornPremature_Update,
    Myle_Faxing_ReturnInboundFaxesToSender,
    Myle_Faxing_GetInboundFaxUnmanagedFaxCount,
    Myle_Faxing_PermanentlyDeleteInboundFaxes,
    Myle_Patient_LoadGrowthCurvesCache,
    Myle_Faxing_AddNoteToInboundFax,
    Myle_Faxing_MarkInboundFaxesAsRead,
    Myle_Faxing_AttachFaxToDocument,
    Myle_Faxing_GetInboundFaxPagesWithDetails,
    Myle_Faxing_UpdateInboundFaxPages,
    Myle_Patient_ExportCharts,
    Myle_Patient_SaveVitalSign,
    Myle_Faxing_GetResponsibleProviders,
    RAMQ_GetSubscribedPatientCount,
    Myle_Patient_DeleteVitalSign = 893,
    Myle_Patient_InvalidateVitalSign,
    Myle_Faxing_GeneratePdfPreview,
    Myle_Faxing_PermanentlyDeleteOldFaxes,
    Myle_Patient_GetGrowthChartSharedItem,
    Myle_Patient_ExportPortalCharts,
    Myle_Faxing_GetPrimaryResponsibleProvider,
    Myle_Faxing_UpdateInboundFax,
    Myle_Patient_LinkNoteToAppointment,
    Myle_BcMedicalServicesPlan_GetEligibility,
    Myle_GetSignedPrintAuthorization,
    Myle_RevokeSignaturePrintAuthorization,
    ExportableFile_GetPrescriptionFetchUrl,
    ExportableFile_GetConsultationRequestFetchUrl,
    ExportableFile_GetExamRequestFetchUrl,
    Myle_UpdatePreferredPharmacy,
    Myle_LogFrontEndError,
    Myle_Faxing_SendFaxRequest,
    Employee_UpdateClickableTextItemOrderNumber,
    Myle_Patient_MedicalNote_GetPendingItems,
    Myle_Patient_MedicalNote_LoadEncountersById,
    Myle_GetFavoriteDiagnoses,
    Myle_ToggleFavoriteMedicalProblem,
    Myle_ExternalCommunication_SearchPatient = 917,
    Myle_ExternalCommunication_SearchPatientPrintableFiles,
    Myle_ExternalCommunication_Request,
    Myle_Faxing_ResendFaxLocal,
    Myle_CnesstModule_SaveTemporaryWorkAssignment,
    Myle_Patient_History_MarkPrivateBillAsPaid,
    Myle_LoadPayableBills,
    Myle_PrivateBill_SaveAndFaxPrivateBill,
    Myle_PrivateBill_SaveRecipientDetailsAndFaxPrivateBill,
    Myle_PrivateBill_SaveAndPrintPrivateBill,
    Myle_Billing_GeneratePayableBillsReportPdf,
    Myle_LoadIndividual,
    Myle_SearchIndividual,
    Myle_CreateRelative,
    Myle_ValidateIndividualDuplicate,
    Myle_Individual_Demographics_Update,
    Myle_Individual_Contacts_Update,
    Myle_Individual_Identifiers_Update,
    Myle_Individual_Relationships_Update,
    Myle_ConvertRelativeToPatient,
    ExportableFile_GetMedicalNoteFetchUrl,
    Myle_PrivateBill_UpsertAndSyncPrivateBill,
    Myle_PrivateBill_Publish,
    Myle_Patient_CreatePrescriptionRenewal,
    Myle_PrescriptionRenewal_CountPrescriptionRenewal,
    Myle_GetPrescriptionRenewals,
    Myle_GetPrescriptionRenewalById,
    Myle_PrescriptionRenewal_GetPrescriptionRenewalMedications,
    Myle_SavePrescriptionRenewalMedications,
    Myle_GetFaxSenderSourceByDocumentId,
    Myle_PrescriptionRenewal_CompletePrescription,
    ExternalBilling_CreateClaimForPrescription,
    Employee_GetPermissionsByEmployee,
    Myle_GetCumulativePatientProfileByPrescriptionRenewal,
    Myle_GetPatientLastAppointment,
    Myle_GetAppointmentResponsibleProviderId,
    Myle_PrescriptionRenewal_Delete,
    Myle_Admin_ExportTimeSlots,
    Myle_Patient_AddConsentProgramHistory,
    Myle_Patient_LoadConsentProgramHistory,
    Myle_Patient_SetRequiredInformation,
    Myle_Faxing_ReturnDocumentWithComment,
    Myle_Patient_CheckAccessWithoutConsentPermission,
    Myle_Patient_AddAccessWithoutConsent,
    Myle_MedicalDocuments_SaveAnnotations,
    Myle_MedicalDocuments_GetAnnotations,
    Myle_ExternalCommunication_LoadLogEntries,
    Myle_LoadBearerTokenForContactDirectory,
    Myle_Patient_PreferredContacts_Load,
    Apss_PatchApssRequest,
    Myle_ForwardApssPatchRequest,
    Myle_Administration_Site_UploadLogo,
    Myle_Billing_LoadClaimStatus,
    Myle_Billing_CountClaimStatus,
    Myle_Billing_AddUpdateReconciliationAction,
    Myle_Billing_GenerateReconciliationPdf,
    Myle_Billing_AddReconciliationNote,
    Myle_Faxing_DissociateClassAndSubClassFromInboundFaxSourceByFaxNumber,
    Myle_PopulationBasedFunding_TransferPatientRegister,
    Myle_PopulationBasedFunding_RegisterPatient,
    Myle_PopulationBasedFundingEvent_GetLatestActiveEvent,
    Myle_PopulationBasedFundingEvent_Delete,
    Myle_PopulationBasedFundingEvent_Edit,
    Myle_Portfolio_GetFilteredPopulationBasedFundingEvents,
    Myle_PopulationBasedFundingEvent_GetActionableProposalCount,
    Myle_PopulationBasedFunding_AcceptProposals,
    Myle_Portfolio_PopulationBasedFunding_PrintPatientRegistry,
    Myle_PopulationBasedFundingEvent_GetPatientHistory,
    Myle_PopulationBasedFunding_OverrideRegistrationProposal,
    Myle_PopulationBasedFunding_OverrideDeregistrationProposal,
    Myle_Patient_MedicalNote_GeneratePatientBillingHistoryPdf,
    MedfarDictionary_GetDiagnosticCodeNames,
    Myle_PopulationBasedFunding_AcceptInternalRegistrationProposal,
    Myle_PopulationBasedFunding_DeregisterPatient,
    Myle_PopulationBasedFunding_GetLatestRegistration,
    Myle_PopulationBasedFunding_CreateTask,
    Myle_PopulationBasedFunding_GetPatientsTasks,
    Myle_PopulationBasedFunding_PatientHasRegistrationHistory,
    Myle_PopulationBasedFunding_CreateInternalRegistrationProposal,
    Myle_PopulationBasedFunding_DeleteInternalRegistrationProposal,
    ExternalBilling_GetClaimsByPatientContactFacetId,
    Myle_Billing_GetServiceFeeCodeDescriptions,
    MedfarDictionary_GetDiagnosticAndFeeCodeDetails,
    Myle_Billing_GeneratePayableBillsCsv,
    Myle_Administration_NotificationConfiguration_Save,
    Myle_Patient_MedicalSummary_UpdateSummaryConfiguration,
    Myle_Patient_MedicalSummary_UpdateNotesFilterConfiguration,
    Myle_Patient_MedicalNote_GetOrCreateEncounterForDirectProfileEdits,
    Myle_Patient_MedicalNote_CancelAutoApprove,
    /** @deprecated Use {@link Myle_MultifactorAuthenticationModule_CurrentUser_GetSettings} instead. */
    Myle_MultifactorAuthenticator_GetInfo,
    /** @deprecated Use {@link Myle_MultifactorAuthenticationModule_CurrentUser_Activate} or {@link Myle_MultifactorAuthenticationModule_CurrentUser_Deactivate} instead */
    Myle_MultifactorAuthenticator_Toggle,
    Myle_Settings_SaveLoginPinFrequency,
    Myle_Settings_LoadLoginPinFrequency,
    ExportableFile_RadPdf_SaveSignaturePositions,
    Myle_Settings_ValidateSignaturePinToken,
    Myle_Settings_RefreshSignaturePinToken,
    Myle_Forms_SaveEmployeeFormSign,
    Myle_Forms_LoadEmployeeFormSign,
    /** @deprecated Use {@link Myle_MultifactorAuthenticationModule_Login_SendCodeByEmail} instead */
    Myle_MultifactorAuthenticator_SendCodeByEmail,
    /** @deprecated Use {@link Myle_MultifactorAuthenticationModule_Admin_DeactivateForUser} instead */
    Myle_MultifactorAuthenticator_DeactivateForEmployee,
    Myle_UpdatePromptedForRecoveryEmailAttribute = 1018,
    Myle_SendNoteEventRequestHandler,
    MedfarDictionary_GetVigilanceQueryViewerData,
    MedfarDictionary_GetVigilanceToken,
    Portal_SendInviteForRegistration,
    /** @deprecated Use {@link Myle_MultifactorAuthenticationModule_CurrentUser_VerifySetupInfo} instead. */
    Myle_MultifactorAuthenticatorCode_Verify,
    /** @deprecated Use {@link Myle_MultifactorAuthenticationModule_CurrentUser_SaveCodeDeliveryMethod} instead. */
    Myle_MultifactorAuthentication_AuthenticatorCodeDeliveryMethod,
    Myle_Faxing_ForceDownloadInboundFax,
    Myle_PharmacyOrder_GetPharmacyOrders,
    Myle_GetPatientsNextAppointments,
    Myle_Patient_MedicalItem_GenerateImmunizationPdf,
    Myle_Faxing_GetSentFaxesByItemIds,
    Myle_PharmacyOrder_ArchiveRestoreOrders,
    Myle_PharmacyOrder_CompletePharmacyOrders,
    Myle_PharmacyOrder_GetPharmacyOrderByOrderId,
    Myle_PharmacyOrder_GeneratePharmacyOrderPdf,
    Myle_PharmacyOrder_SendPatientReminder,
    Myle_ExternalBilling_GetSingleUseClaimUri,
    Myle_OntarioHealthInsurancePlan_GetEligibility,
    Myle_Patient_UpdateMedicationPatientCompliance,
    Myle_Patient_MedicalNote_ModifyMedicalRequestRecipient,
    Portal_RefusePatientAccountStatus,
    Portal_GetPortalAccountInfo,
    Myle_ProvincialHealthInsurancePlan_GetEligibility,
    Myle_ConsultationRequest_EditCommentAndStatus,
    Myle_PharmacyOrder_FilePharmacyOrder,
    Myle_ExternalBilling_CreateClaimForEnrollment,
    Myle_GetTermsAndConditionsAgreement,
    Myle_AgreeToTermsAndConditions,
    Myle_AddPrescriptionPdfPrintHistory,
    Myle_Portfolio_PreventiveCare_LoadRecallList,
    Myle_Patient_SaveMergeRequest,
    Myle_Patient_GetCurrentMergeRequest,
    Myle_Patient_CancelMergeRequest,
    Myle_CallCenter_GetContactsMatchingPhoneNumber,
    Myle_CallCenter_Login,
    Myle_CallCenter_GetUserSettings,
    Myle_CallCenter_Logout,
    Myle_CallCenter_UpdateUserOptions,
    Myle_CallCenter_UpdateUserCredentials,
    Myle_CallCenter_ClickToDial,
    Myle_CallCenter_Ping,
    Myle_CallCenter_CallCommunicationAdd,
    Myle_CallCenter_CallCommunicationUpdate,
    Myle_CallCenter_CallCommunicationDelete,
    Myle_Patient_AddMedicationNote,
    Myle_Patient_GetMedicationNotes,
    Myle_Administration_GetRoleDetail,
    Myle_Administration_UpdateRole,
    Myle_Administration_DeleteRole,
    Myle_Administration_GetRoleHeaders,
    Myle_Administration_CreateRole,
    Myle_Administration_GetRoleExclusiveUsers,
    Myle_PharmacyOrder_GeneratePharmacyOrderFormUrl,
    Myle_Portfolio_PreventiveCare_LoadNotices,
    Myle_Portfolio_PreventiveCare_GenerateLetters,
    Myle_Portfolio_PreventiveCare_SaveNotice,
    Myle_Portfolio_PreventiveCare_GenerateBonus,
    Myle_PortalCommunication_GetPortalCommunications,
    Myle_PortalCommunication_GetPatientSharedItemMessages,
    Myle_PortalCommunication_UpdateSharedItemMessagePriority,
    Myle_PortalCommunication_UpdateSharedItemCategory,
    Myle_PortalCommunication_UpdateSharedItemArchivedStatus,
    Myle_PortalCommunication_UpdateSharedItemMessageReadStatus,
    Myle_PortalCommunication_FlagSharedItemForReview,
    Myle_PortalCommunication_LoadSharedItemNotes,
    Myle_PortalCommunication_SaveSharedItemNote,
    MedfarDictionary_GetVigilanceProductLimitedUseCodes,
    MedfarDictionary_GetVigilanceLimitedUseCodeDescription,
    Gde_Proxy_GetNewDocumentRedirectUrl,
    Gde_GetNewDocumentRedirectUrl,
    Myle_LoadProtectedPatient,
    Myle_AIScribe_LinkUser,
    Myle_AIScribe_SynchronizeConsultationNote,
    Myle_AIScribe_StartConsultation,
    Myle_AIScribe_UpdateConsultationRecordingDuration,
    Myle_AIScribe_UpdateConsultationGenerationFailureReason,
    Myle_Patient_MedicalNote_AppendEncounterProgressNoteFields,
    Myle_PortalCommunication_SetPatientSendingSettingsBlockedStatus = 1097,
    Myle_PortalCommunication_IncreasePatientSendingSettingsMessagesLimit,
    Myle_PortalCommunication_GetPatientSendingSettings,
    Myle_FlowsheetModule_CreateFlowsheet,
    Myle_FlowsheetModule_DeleteFlowsheet,
    Myle_FlowsheetModule_GetFlowsheet,
    Myle_FlowsheetModule_FindFlowsheetSummaries,
    Myle_FlowsheetModule_GetFlowsheetsCount,
    Myle_FlowsheetModule_GetFlowsheetTemplatesMetadata,
    Myle_FlowsheetModule_SaveFlowsheet,
    Myle_PortalCommunication_GetPatientPortalCommunications,
    Myle_OacisModule_GetOacisLaunchPayload,
    Myle_LabResults_SaveManualEntry,
    Myle_FlowsheetModule_SaveFilterSettings,
    Myle_AIScribe_LogMarketingPopupDisplay,
    Myle_CDSExport_SaveOntarioCommonDataSetExport,
    Myle_FlowsheetModule_GetFlowsheetTemplate,
    Myle_FlowsheetModule_CreateFlowsheetTemplate,
    Myle_FlowsheetModule_DeleteFlowsheetTemplate,
    Myle_FlowsheetModule_GetFlowsheetTemplateNameExists,
    Myle_PortalCommunication_GetSharedItemCategories,
    Myle_ManualLabResults_GetFilteredLabAnalysisDefinitions,
    Myle_Faxing_ResendFaxWithChanges,
    Myle_Patient_SetMedicalSummaryVisibilityForExport,
    Myle_Patient_MarkTestStatus,
    Myle_FlowsheetModule_PrintFlowsheet,
    Myle_Patient_GetPatientPdfInformation,
    Myle_ManualLabResults_GetManualLabResults,
    Myle_ManualLabResults_FileManualLabResults,
    Myle_ManualLabResults_GetNewManualLabResultsCount,
    Myle_AIScribe_UnlinkUser,
    Myle_OlisModule_GetLabInfoForPatient,
    Myle_CnesstModule_LoadEncounterFormsByEncounterIds,
    Myle_GetEncounterFormsTitles,
    Myle_OlisModule_SearchLabsByText,
    Myle_OlisModule_SearchTestCodesByText,
    Myle_MultifactorAuthenticationModule_Admin_DeactivateForUser,
    Myle_MultifactorAuthenticationModule_CurrentUser_Activate,
    Myle_MultifactorAuthenticationModule_CurrentUser_Deactivate,
    Myle_MultifactorAuthenticationModule_CurrentUser_GenerateSetupInfo,
    Myle_MultifactorAuthenticationModule_CurrentUser_GetSettings,
    Myle_MultifactorAuthenticationModule_CurrentUser_SaveCodeDeliveryMethod,
    Myle_MultifactorAuthenticationModule_CurrentUser_SendSetupCodeByEmail,
    Myle_MultifactorAuthenticationModule_CurrentUser_VerifySetupInfo,
    Myle_MultifactorAuthenticationModule_Login_SendCodeByEmail,
    Myle_MultifactorAuthenticationModule_Login_SkipSetup,
    Myle_OntarioMdHealthReportManagerModule_TriggerPull,
    Myle_AuthenticationModule_GetAccessInfo,
    Myle_OlisModule_GetLabResultPreview,
    Myle_CDSExport_SaveOntarioCommonDataSetImport,
    Myle_StreamlineNoteCompletion_SaveNoteActionButtonLog,
    Myle_OntarioMdHealthReportManagerModule_QueryOrphanDocuments,
    Myle_OntarioDigitalHealthDrugRepositoryModule_SearchMedicationDocumentBundle,
    Myle_OlisModule_DeleteLabResult,
    Myle_OlisModule_ImportLabResult,
    Myle_OntarioMdHealthReportManagerModule_LinkPatient,
    Myle_FavoritePreventiveActivity_GetItems,
    Myle_FavoritePreventiveActivity_ToggleItem,
    Myle_InstantMessagingModule_GetToken,
    Myle_OntarioMdHealthReportManagerModule_GetNotifications,
    Myle_OntarioMdHealthReportManagerModule_PushNotification,
    Myle_OntarioMdHealthReportManagerModule_HideNotification,
    Hrm_GetMyHrmDocumentShares,
    Hrm_GetHrmSharesWithMe,
    Hrm_SaveMyHrmDocumentShares,
    Myle_OntarioMdHealthReportManagerModule_GetConfidentialityStatement,
    Myle_OntarioMdHealthReportManagerModule_UpdateConfidentialityStatement,
    Myle_OntarioMdHealthReportManagerModule_CreateCustomDocumentClass,
    Myle_OntarioMdHealthReportManagerModule_CleanupData,
    Myle_OntarioMdHealthReportManagerModule_GetRawMetadata,
    Myle_OntarioMdHealthReportManagerModule_GetOrphanDocumentsCount,
    Myle_InstantMessagingModule_GetGroupChatChannels,
    Myle_InstantMessagingModule_GetUsers,
    Myle_InstantMessagingModule_CreateGroupChannel,
    Myle_InstantMessagingModule_UpdateGroupChannel,
}

export { Server };
